'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import type { ListEventGiftBoxDto } from '@generated/auth';
import { useSuspenseQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';
import { AuthQueryOptions } from '@/api';
import { GroupLine } from './GroupLine';
import { InviteHistoryListItem } from './InviteHistoryListItem';
export const HistoryListSection = () => {
  const $ = _c(12);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      ...AuthQueryOptions["get:/wello/v2/auth/home-donation-event-gift-box/opened"]({
        query: {
          page: 1,
          size: 9999
        }
      }),
      select: _temp2
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data: augustList
  } = useSuspenseQuery(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      ...AuthQueryOptions["get:/wello/v2/auth/home-donation-event-history"]({
        query: {
          page: 1,
          size: 9999
        }
      }),
      select: _temp4
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    data: septemberList
  } = useSuspenseQuery(t1);
  const totalCount = augustList.totalCount + septemberList.totalCount;
  const isEmpty = totalCount < 1;
  let t2;
  let t3;
  if ($[2] !== augustList.list || $[3] !== isEmpty || $[4] !== septemberList.list || $[5] !== totalCount) {
    const list = [...septemberList.list, ...augustList.list];
    const groupedByMonth = list.reduce(_temp5, {} as Record<string, {
      label: string;
      items: ListEventGiftBoxDto[];
    }>);
    const sortedGroups = Object.entries(groupedByMonth);
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = cn("flex flex-col gap-16", "mobile-tablet:px-20");
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    t3 = !isEmpty ? <section className="flex flex-col gap-10"><p className="font-600 text-Gray-900 typo-body4">총 <span className="text-B-500">{totalCount.toLocaleString()}</span>건</p><div className="flex flex-col">{sortedGroups.map(_temp6)}</div></section> : null;
    $[2] = augustList.list;
    $[3] = isEmpty;
    $[4] = septemberList.list;
    $[5] = totalCount;
    $[6] = t2;
    $[7] = t3;
  } else {
    t2 = $[6];
    t3 = $[7];
  }
  let t4;
  if ($[9] !== t2 || $[10] !== t3) {
    t4 = <article className={t2}>{t3}</article>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
function _temp(item) {
  return {
    daysAgo: item.daysAgo,
    eventDisplayText: item.eventDisplayText,
    openedAt: item.openedAt,
    rewardPoint: item.rewardPoint
  };
}
function _temp2(data) {
  return {
    list: data.context?.contents.map(_temp) ?? [],
    totalCount: data.context?.totalCount ?? 0
  };
}
function _temp3(item_0) {
  return {
    daysAgo: item_0.daysAgo,
    eventDisplayText: item_0.eventDisplayText,
    openedAt: item_0.createdAt,
    rewardPoint: item_0.rewardPoint
  };
}
function _temp4(data_0) {
  return {
    list: data_0.context?.contents.map(_temp3) ?? [],
    totalCount: data_0.context?.totalCount ?? 0
  };
}
function _temp5(groups, item_1) {
  const date = dayjs(item_1.openedAt);
  const monthKey = date.format("YYYY-MM");
  const monthLabel = `${date.month() + 1}월`;
  if (!groups[monthKey]) {
    groups[monthKey] = {
      label: monthLabel,
      items: []
    };
  }
  groups[monthKey].items.push(item_1);
  return groups;
}
function _temp6(t0) {
  const [monthKey_0, group] = t0;
  return <div key={monthKey_0} className="flex flex-col gap-8"><GroupLine label={group.label} /><ul className="flex flex-col gap-2">{group.items.map((t1, index, array) => {
        const {
          daysAgo: days_ago,
          eventDisplayText: event_display_text,
          rewardPoint: reward_point
        } = t1;
        return <InviteHistoryListItem key={`${monthKey_0}-${index}`} daysAgo={days_ago} eventDisplayText={event_display_text} rewardPoint={reward_point} hideLine={index === array.length - 1} />;
      })}</ul></div>;
}